import React from 'react';
import RolloutStatusBadge from './RolloutStatusBadge';
import { formatDatetime, modeLabelMap } from '../lib/recoveryRolloutFormatters';

const RecoveryRolloutModeCard = ({ currentMode, targetMode, readiness, lastUpdated }) => {
  return (
    <section className="rounded-xl border border-slate-800 bg-slate-900/70 p-4">
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div>
          <p className="text-xs uppercase tracking-[0.14em] text-slate-400">Mode Aktif</p>
          <h2 className="mt-1 text-lg font-semibold text-slate-100">{modeLabelMap[currentMode] || currentMode || '-'}</h2>
          <p className="mt-1 text-xs text-slate-400">Target berikut: {modeLabelMap[targetMode] || targetMode || '-'}</p>
          <p className="mt-1 text-[11px] text-slate-500">Last update: {formatDatetime(lastUpdated || readiness?.evaluatedAt)}</p>
        </div>
        <RolloutStatusBadge status={readiness?.readinessStatus || 'BLOCKED'} />
      </div>
      <p className="mt-3 rounded-lg border border-slate-800 bg-slate-950/70 px-3 py-2 text-sm text-slate-300">
        {readiness?.recommendation || 'Belum ada evaluasi readiness.'}
      </p>
    </section>
  );
};

export default RecoveryRolloutModeCard;
